import { getUserInfo } from 'src/modules/authHandler';

declare global {
  interface Window {
    FS: any;
    Intercom: any;
    INTERCOM_APP_ID: string;
  }
}

// ================================================================
// Fullstory
// ================================================================
interface FullstoryArgs {
  userId: number;
  name: string;
}

export const getFullStoryScriptTag = () =>
  `<script>
window['_fs_debug'] = false;
window['_fs_host'] = 'fullstory.com';
window['_fs_org'] = 'HZH4R';
window['_fs_namespace'] = 'FS';
(function(m,n,e,t,l,o,g,y){
    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
    o=n.createElement(t);o.async=1;o.src='https://'+_fs_host+'/s/fs.js';
    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
    g.consent=function(a){g("consent",!arguments.length||a)};
    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
    g.clearUserCookie=function(){};
})(window,document,window['_fs_namespace'],'script','user');
</script>`;

export const initializeFullStory = ({ userId, name }: FullstoryArgs) => {
  if (!window.FS) {
    return;
  }

  window.FS.identify(userId, {
    displayName: name,
  });
};

interface AccountInfo {
  name: string;
  userId: number;
  billingId: string;
}

// ================================================================
// Intercom
// ================================================================

export const getIntercomScriptTag = () =>
  `<script> 
  (function() {
    var w = window;
    var ic = w.Intercom;
    w.INTERCOM_APP_ID = 'f28vuejb';
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function() {
        i.c(arguments);
      };
      i.q = [];
      i.c = function(args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function() {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + w.INTERCOM_APP_ID;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
  </script>`;

export const initializeIntercom = async (accountInfo: AccountInfo) => {
  if (!window.Intercom) {
    return;
  }

  const userInfo = await getUserInfo();
  if (userInfo) {
    const { name, userId, billingId } = accountInfo || {};
    // eslint-disable-next-line new-cap
    window.Intercom('boot', {
      app_id: window.INTERCOM_APP_ID,
      email: userInfo.email,
      name,
      user_id: userId,
      billingId,
    });
  }
};
